import React from 'react'
import PropTypes from 'prop-types'

const InputColor = React.forwardRef((props, ref) => {
    const {name, label, value, ...other} = props
    return <div className={`flex flex-row items-center mt-2`}>
        <input ref={ref} value={value} name={name} type='color' {...other}
               className={`input-text p-1 h-10 ${'disabled' in props ? '' : 'cursor-pointer'}`}/>
        <span className='ml-2'>{label || 'Select color'}</span>
    </div>
})

InputColor.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    label: PropTypes.string
}

export default InputColor
